import React, { useState, useEffect } from "react";
import "./alert.css"; // Import external CSS for styling
import { FaCheckCircle } from "react-icons/fa"; // Import done icon from React Icons

const Alert = () => {
  // Array of alert messages
  const alertMessages = [
    "An Investor From Albania withdrew $31,000...",
    "An Investor From UK withdrew $4,50...",
    "An Investor From Jersey withdrew $10,00...",
    "An Investor From Guinea withdrew $1,020...",
    "An Investor From Sweden withdrew $37,80...",
    "An Investor From Chad deposited $5,000...",
    "An Investor From Panama withdrew $120...",
    "An Investor From Albania withdrew $31,000",
    "An Investor From Peru withdrew $1,02...",
    "An Investor From Chad deposited $5,00...",
  ];

  const [currentAlert, setCurrentAlert] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Trigger fade-out
      setIsVisible(false);

      // Wait for fade-out transition to complete before updating alert
      setTimeout(() => {
        setCurrentAlert((prev) => (prev + 1) % alertMessages.length);
        setIsVisible(true); // Trigger fade-in
      }, 1000); // Match the duration of the fade-out transition
    }, 6000);

    return () => clearInterval(interval); // Cleanup interval
  }, [alertMessages.length]);

  return (
    <div className={`alert-container ${isVisible ? "visible" : "hidden"}`}>
      <div className="alert-box">
        <FaCheckCircle className="icon" />
        <span>{alertMessages[currentAlert]}</span>
      </div>
    </div>
  );
};

export default Alert;
